<template>
  <h1 class="text-3xl sm:text-4xl md:text-5xl font-semibold v-leading-small" :class="textColor">
    <slot />
  </h1>
</template>

<script setup lang="ts">
defineProps({
  textColor: { type: String, required: false, default: 'text-app-primary-1-red--fire-brick' },
})
</script>

<style lang="scss" scoped>
.v-leading-small {
  line-height: 1.15;
}
</style>
